import React from "react";
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
} from "react-router-dom";

import NotFound from "./generalComponents/notFound";
import LoginPage from "./auth/login";
import RegisterPage from "./auth/register";

import PasswordResetRequest from "./auth/passwordResetRequest";
import ResetRequest from "./auth/resetPassword";

import Checkoutform from "./pages/endOfSummer/form";

import AdminLogin from "./admin/AdminLogin";
import AdminLayout from "./admin/AdminLayout";
import AdminProtectedRoute from "./admin/AdminProtectedRoute";
import AttendeesPage from "./admin/AttendeesPage";
import EventsPage from "./admin/EventsPage";
import EventAdminPage from "./admin/EventAdminPage";
import IntegrationsPage from "./admin/IntegrationsPage";

import EventsList from "./pages/events/EventsList";
import EventPage from "./pages/events/EventPage";

export default function Routers(appProps) {
  const navigate = useNavigate();

  const LogoutPage = ({ isLoading, logout, redirectPath = "/" }) => {
    logout();
    navigate(0);
    return <Navigate to={redirectPath} replace />;
  };

  const guestRoutes = [
    { path: "/", element: <EventsList {...appProps} /> },
    {
      path: "/end-of-summer",
      element: <Checkoutform {...appProps} {...{ isLocked: false }} />,
    },
  ];
  return (
    <Routes>
      <Route path="*" element={<Navigate to="/404" replace />}></Route>
      <Route exact path="/404" element={<NotFound {...appProps} />} />
      <Route
        exact
        path="/reset-password"
        element={<PasswordResetRequest />}
      ></Route>
      <Route
        exact
        path="/set-password/:token"
        element={<ResetRequest />}
      ></Route>

      <Route
        exact
        path="/logout"
        element={<LogoutPage {...appProps} />}
      ></Route>
      <Route>
        <Route>
          <Route
            exact
            path="/login"
            element={<LoginPage {...appProps} />}
          ></Route>
          <Route
            exact
            path="/register"
            element={<RegisterPage {...appProps} />}
          ></Route>
        </Route>
      </Route>

      <Route exact path="/events" element={<EventsList />}></Route>
      <Route
        exact
        path="/event/:eventKey"
        element={<EventPage {...appProps} />}
      ></Route>

      {guestRoutes.map((item) => {
        return (
          <Route
            exact
            key={item.path}
            path={item.path}
            element={item.element}
          ></Route>
        );
      })}

      <Route exact path="/admin/login" element={<AdminLogin />}></Route>
      <Route
        path="/admin"
        element={
          <AdminProtectedRoute>
            <AdminLayout />
          </AdminProtectedRoute>
        }
      >
        <Route index element={<Navigate to="attendees" replace />} />
        <Route path="attendees" element={<AttendeesPage />} />
        <Route path="events" element={<EventsPage />} />
        <Route path="events/:eventKey" element={<EventAdminPage />} />
        <Route path="integrations" element={<IntegrationsPage />} />
      </Route>
    </Routes>
  );
}
